import { Divider, Drawer, List, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import AppConfigContainer from "../providers/AppConfigContainer";
import FiltersContainer from "../providers/FiltersContainer";
import GeoserverConfigContainer from "../providers/GeoserverConfigContainer";
import MapContainer from "../providers/MapContainer";
import MapLayerSelectionContainer from "../providers/MapLayerSelectionContainer";
import MapRouterContainer from "../providers/MapRouterContainer";
import { SearchForCityContainer } from "../providers/SearchContainer";
import { DRAWER_WIDTH } from "../utils/constants";
import DashBoardButton from "./Buttons/DashBoardButton";
import Filter from "./filters";
import { Loading } from "./Loading";
import Logo from "./Logo";
import Map from "./map";
import PlacesContainer from "../providers/PlacesContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    marginLeft: DRAWER_WIDTH,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: DRAWER_WIDTH,
    flexShrink: 0,
  },
  drawerPaper: {
    width: DRAWER_WIDTH,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -DRAWER_WIDTH,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function MainDrawerPage() {
  const classes = useStyles();
  const open = true;

  return (
    <AppConfigContainer>
      <FiltersContainer>
        <GeoserverConfigContainer>
          <div className={classes.root}>
            <Loading />
            <Drawer
              className={classes.drawer}
              variant="persistent"
              anchor="left"
              open={open}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <Logo />
              <Divider />
              <List>
                <Filter />
              </List>

              <DashBoardButton />
            </Drawer>
            <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
            >
              <MapContainer>
                <MapRouterContainer>
                  <MapLayerSelectionContainer>
                    <SearchForCityContainer>
                      <PlacesContainer>
                        <Map />
                      </PlacesContainer>
                    </SearchForCityContainer>
                  </MapLayerSelectionContainer>
                </MapRouterContainer>
              </MapContainer>
            </main>
          </div>
        </GeoserverConfigContainer>
      </FiltersContainer>
    </AppConfigContainer>
  );
}
